import request from '@/plugins/axios'

export function getAllCommodityType (data) {
  return request({
    url: '/home/getAllCommodityType',
    method: 'post',
    data
  })
}

export function getCommodityList (data) {
  return request({
    url: '/home/getCommodityList',
    method: 'post',
    data
  })
}

export function getCarouselImg (data) {
  return request({
    url: '/home/getCarouselImg',
    method: 'post',
    data
  })
}